import { UserInfo } from "../types";

export type SessionState = {
    status: 'loading' | 'ready';
    user: UserInfo | null;
    selectedOrgId?: string;
};

export type SessionAction =
    | { type: 'AUTH_SUCCESS'; user: UserInfo }
    | { type: 'AUTH_FAILURE' }
    | { type: 'LOGOUT' }
    | { type: 'SWITCH_ORG'; organizationId: string };

export const initialSessionState: SessionState = {
    status: 'loading',
    user: null,
    selectedOrgId: undefined,
};

export function sessionReducer(state: SessionState, action: SessionAction): SessionState {
    switch (action.type) {
        case 'AUTH_SUCCESS':
            return { status: 'loading', user: action.user, selectedOrgId: undefined };
        case 'AUTH_FAILURE':
            return { status: 'ready', user: null, selectedOrgId: undefined };
        case 'LOGOUT':
            return { status: 'ready', user: null, selectedOrgId: undefined };
        case 'SWITCH_ORG':
            return { ...state, status: 'ready', selectedOrgId: action.organizationId };
    }
}
